import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../../hooks/axiosInstance";
import { toast } from "react-toastify";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Oval } from "react-loader-spinner";
import CreateInvoice from "../../../components/Modal/Admin/Invoicing/CreateInvoicing";
import ViewInvoice from "../../../components/Modal/Admin/Invoicing/ViewInvoice";
import EditInvoicing from "../../../components/Modal/Admin/Invoicing/EditInvoicing";
import AddCustomServicePayment from "../../../components/Modal/Admin/Invoicing/AddCustomServicePayment";
import ViewCustomFixedPayHistory from "../../../components/Modal/Admin/Invoicing/ViewCustomFixedPayHistory";
import { Button, Modal, Spinner } from "react-bootstrap";


export default function Invoicing() {

    const [items, setItems] = useState([]);
    const [pagination, setPagination] = useState({});
    const [page, setPage] = useState(1);
    const [showManageModal, setShowManageModal] = useState(false);
    const [showPayment, setShowPayment] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false); // State for EditModal
    const [showViewModal, setShowViewModal] = useState(false); // State for EditModal
    const [selectedItem, setSelectedItem] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
    const [isGeneralLoading, setIsGeneralLoading] = useState(false);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [documentFilter, setDocumentFilter] = useState("");
    const [type, setType] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [paymentHistories, setPaymentHistory] = useState(null);
    const [showPaymentHistory, setShowPaymentHistory] = useState(false);

    const [percentageModalOpen, setPercentageModalOpen] = useState(false);
    const [percentage, setPercentage] = useState('');
    const [currentAccountId, setCurrentAccountId] = useState(null);
    const [baseUser, setBaseUser] = useState([]);
    const [selectedBaseUserId, setSelectedBaseUserId] = useState(null);
    const [fixedProducts, setFixedProducts] = useState([]);
    const [customProducts, setCustomProducts] = useState([]);
    const [selectedProductId, setSelectedProductId] = useState("");
    const [selectedCustomProductId, setSelectedCustomProductId] = useState("");
    const [totalAmountSum, setTotalAmountSum] = useState(0);
    const [totalBalanceSum, setTotalBalanceSum] = useState(0);

    useEffect(() => {
        const fetchItems = async () => {
            setIsGeneralLoading(true);

            try {
                const response = await axiosInstance.get(`user/invoice_custom_service/fetch`, {
                    params: {
                        page,
                        filter: searchQuery,
                        start_date: startDate, // Pass start date
                        end_date: endDate,     // Pass end date
                        status: statusFilter,
                        type: type,
                        document_type: documentFilter,
                        base_user: selectedBaseUserId || "",
                        product_id: selectedProductId,
                        custom_product_id: selectedCustomProductId,
                    },
                });
                setItems(response.data.data.invoices.data);

                setPagination(response.data.data.invoices);
                setTotalAmountSum(response.data.data.total_amount_sum || 0);
                setTotalBalanceSum(response.data.data.total_balance_sum || 0);
                // console.log(response.data.data.invoices.data);

            } catch (error) {
                console.error("Error fetching items:", error);
            } finally {
                setIsGeneralLoading(false);
            }
        };

        fetchItems();
    }, [page, selectedBaseUserId, refreshKey, searchQuery, startDate, type, endDate, statusFilter, documentFilter, selectedProductId, selectedCustomProductId]);

    useEffect(() => {
        const fetchBaseUser = async () => {
            setIsGeneralLoading(true);
            try {
                const response = await axiosInstance.get(
                    `/user/base_user/fetch_base_user_no_paginate`
                );

                setBaseUser(response.data.data.base_user || []);

            } catch (error) {
                toast.error("Error fetching users:", error);
            }
            finally {
                setIsGeneralLoading(false); // Hide loader after fetching
            }
        };

        fetchBaseUser();
    }, []);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                // Fetch Fixed Products
                const fixedResponse = await axiosInstance.get("/user/product/fetch?list=1");
                setFixedProducts(fixedResponse.data.data.products || []);

                // Fetch Custom Products
                const customResponse = await axiosInstance.get("/user/custom_product/fetch_no_paginate");
                setCustomProducts(customResponse.data.data.products || []);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
        };

        fetchProducts();
    }, []);

    const handleProductSelect = (event) => {
        setSelectedProductId(event.target.value);
    };

    const handleCustomProductSelect = (event) => {
        setSelectedCustomProductId(event.target.value);
    };

    const handleBaseUserSelect = (event) => {
        setSelectedBaseUserId(event.target.value);
    };
    const handleShowManageModal = (item) => {
        setSelectedItem(item);
        setShowManageModal(true);
    };

    const handleShowEditModal = (item) => {
        setSelectedItem(item);
        setShowEditModal(true);
    };
    const handleShowPayment = (item) => {
        setSelectedItem(item);
        setShowPayment(true);
    };

    const handleShowViewInvoice = (item) => {
        setSelectedItem(item);
        setShowViewModal(true);
    };

    const handleShowPaymentHistory = (item) => {
        setPaymentHistory(item);
        setShowPaymentHistory(true);
    };


    const handleCloseViewPaymentHistory = () => {
        setShowPaymentHistory(false);
        setPaymentHistory(null);
    };

    const MySwal = withReactContent(Swal);

    const handleDelete = async (invoice_code) => {
        const result = await MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            try {
                await axiosInstance.post(`user/invoice_custom_service/delete/${invoice_code}`);
                toast.success("Invoice deleted successfully!");
                handleRefresh();
            } catch (error) {
                console.error("Error deleting Invoice:", error);
                toast.error("Error deleting Invoice.");
            }
        }
    };

    const handleCloseManageModal = () => {
        setShowManageModal(false);
        setSelectedItem(null);
    };

    const handleClosePayment = () => {
        setShowPayment(false);
        setSelectedItem(null);
    };

    const handleCloseEditModal = () => {
        setShowEditModal(false);
        setSelectedItem(null);
    };
    const handleCloseViewModal = () => {
        setShowViewModal(false);
        setSelectedItem(null);
    };

    const handleRefresh = () => {
        setRefreshKey((prevKey) => prevKey + 1);
    };

    const handlePageChange = (newPage) => {
        if (newPage > 0 && newPage <= pagination.last_page) {
            setPage(newPage);
        }
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleStartDateChange = (event) => {
        setStartDate(event.target.value);
    };

    const handleEndDateChange = (event) => {
        setEndDate(event.target.value);
    };
    const handleTypeChange = (event) => {
        setType(event.target.value);
    };

    const handleStatusFilterChange = (event) => {
        setStatusFilter(event.target.value);
    };

    const handleDocumentFilterChange = (event) => {
        setDocumentFilter(event.target.value);
    };

    // Function to format amount with commas
    const formatAmount = (amount) => {
        return new Intl.NumberFormat().format(amount);
    };

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const groupedItems = items.reduce((acc, item) => {
        const invoiceCode = item.invoice_code;

        if (!acc[invoiceCode]) {
            acc[invoiceCode] = {
                invoice_code: invoiceCode,
                customer: item.account,
                amount: 0,
                quantity: 0,
                discount: 0,
                totalAmount: 0,
                amountPaid: 0,
                balance: 0
            };
        }

        // Aggregate data for each customer
        acc[invoiceCode].amount += parseFloat(item.amount) || 0;
        acc[invoiceCode].quantity += parseFloat(item.quantity) || 0;
        acc[invoiceCode].discount += parseFloat(item.discount) || 0;
        acc[invoiceCode].totalAmount += parseFloat(item.total_amount) || 0;
        acc[invoiceCode].amountPaid += parseFloat(item.amount_paid) || 0;
        acc[invoiceCode].balance += parseFloat(item.balance) || 0;
        acc[invoiceCode].created_at = item.created_at || '';


        return acc;
    }, {});
    const aggregatedItems = Object.values(groupedItems);



    const [analytic, setAnalytic] = useState(null);

    useEffect(() => {
        const fetchAnalytic = async () => {
            try {
                const response = await axiosInstance.get("/user/fetch-analytic");
                setAnalytic(response.data.data.data);
            } catch (error) {
                console.error("Error fetching analytic:", error);
            }
        };

        fetchAnalytic();
    }, []);

    const handleDownloadPdf = async (invoice_code) => {
        try {
            setIsGeneralLoading(true);
            const response = await axiosInstance.get(`user/invoice_custom_service/download_invoice_pdf/${invoice_code}`, {
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `invoice_${invoice_code}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            toast.success("Invoice PDF downloaded successfully!");
        } catch (error) {
            console.error("Error downloading PDF:", error);
            toast.error("Failed to download invoice PDF.");
        } finally {
            setIsGeneralLoading(false);
        }
    };
    const sendInvoiceEmail = async (invoice_code) => {
        setIsGeneralLoading(true);

        try {
            // Send the percentage to the backend along with the invoice
            await axiosInstance.post(
                `user/invoice_custom_service/send_fixed_custom_invoice_mail/${invoice_code}`,
                { percentage: parseFloat(percentage) } // Assuming backend expects this format
            );
            toast.success("Invoice email sent successfully with discount applied!");
        } catch (error) {
            console.error("Error sending invoice email:", error);
            toast.error("Failed to send invoice email.");
        } finally {
            setIsGeneralLoading(false);
            setPercentageModalOpen(false); // Close modal after submission
            setPercentage(''); // Reset percentage input
        }
    };

    return (
        <div className="manage-permissions">
            {/* <!-- start page title --> */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0" style={{ color: "#c4281c" }}>
                            Invoicing
                        </h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item">
                                    <Link to="/app/dashboard">Invoicing</Link>
                                </li>
                                <li
                                    className="breadcrumb-item active"
                                    style={{ color: "#c4281c" }}
                                >
                                    Invoicing
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- end page title --> */}
            {isGeneralLoading && !searchQuery ? ( // Only show loader for general data fetching
                <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "80vh" }}
                >
                    <Oval
                        height={80}
                        width={80}
                        color="#FF0200"
                        visible={true}
                        ariaLabel="oval-loading"
                        secondaryColor="#4fa94d"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                    />
                </div>
            ) : (
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body border border-dashed border-end-0 border-start-0">
                                <div className="d-flex justify-content-end mb-4">
                                    <button
                                        className="vehicle-button btn btn-primary"
                                        style={{ backgroundColor: "#c4281b", color: "#fff", border: "none" }}
                                        onClick={() => setShowManageModal(true)}
                                    >
                                        <i className="mdi mdi-plus-circle-outline"></i> Add Invoice
                                    </button>
                                </div>
                                <div className="row mb-3">
                                </div>
                                <div className="row mb-3">
                                    <div className="col-xl-4 col-md-6">
                                        <div className="search-box">
                                            <input
                                                type="text"
                                                className="form-control search"
                                                placeholder="Search..."
                                                value={searchQuery}
                                                onChange={handleSearchChange}
                                            />
                                            <i className="ri-search-line search-icon"></i>
                                        </div>
                                    </div>

                                    <div className="col-xl-4 col-md-6">
                                        <div className="input-group mb-2">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    Payment Status&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                                </span>
                                            </div>
                                            <select
                                                className="form-select"
                                                value={statusFilter}
                                                onChange={handleStatusFilterChange}
                                            >
                                                <option value="">All Status</option>
                                                <option value="paid">Paid</option>
                                                <option value="unpaid">Unpaid</option>
                                                <option value="partly_paid">Partly Paid</option>
                                                <option value="due">Due</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6">
                                        <div className="input-group mb-2">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    Renewal&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                                </span>
                                            </div>
                                            <select
                                                className="form-select"
                                                value={type}
                                                onChange={handleTypeChange}
                                            >
                                                <option value="">--type--</option>
                                                <option value="custom">Fixed</option>
                                                <option value="service">Custom</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6 ml-2">
                                        <div className="input-group mb-2">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    Select a base user &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;{" "}
                                                </span>
                                            </div>
                                            <select
                                                className="custom-select form-control"
                                                value={selectedBaseUserId || ""}
                                                onChange={handleBaseUserSelect}
                                            >
                                                <option value="">--select base-user--</option>
                                                {baseUser.map((baseUser) => (
                                                    <option key={baseUser.id} value={baseUser.id}>
                                                        {baseUser.first_name} {baseUser.last_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-xl-4 col-md-6">
                                        <div className="input-group mb-2">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    Document Status&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                                </span>
                                            </div>
                                            <select
                                                className="form-select"
                                                value={documentFilter}
                                                onChange={handleDocumentFilterChange}
                                            >
                                                <option value="">Document Type</option>
                                                <option value="invoice">Invoice</option>
                                                <option value="quotation">Quotation</option>
                                            </select>
                                        </div>
                                    </div>
                                    {/* {type === 'custom' && (
                                        <div className="col-xl-4 col-md-6">
                                            <div className="input-group mb-2">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        Fixed Product &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                                    </span>
                                                </div>
                                                <select
                                                    className="custom-select form-control"
                                                    value={selectedProductId}
                                                    onChange={handleProductSelect}
                                                >
                                                    <option value="">--All Fixed Products--</option>
                                                    {fixedProducts.map((product) => (
                                                        <option key={product.id} value={product.id}>
                                                            {product.product_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )}
                                    {type === 'service' && (
                                        <div className="col-xl-4 col-md-6">
                                            <div className="input-group mb-2">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        Custom Product &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                                                    </span>
                                                </div>
                                                <select
                                                    className="custom-select form-control"
                                                    value={selectedCustomProductId}
                                                    onChange={handleCustomProductSelect}
                                                >
                                                    <option value="">--All Custom Products--</option>
                                                    {customProducts.map((product) => (
                                                        <option key={product.id} value={product.id}>
                                                            {product.product_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )} */}
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row mb-3 mt-n2">
                                    <div className="col-12 text-end">
                                        <div className="p-2 rounded bg-light border d-inline-block">
                                            <span className="fw-bold me-3">Total Amount: ₦{formatAmount(totalAmountSum)}</span>
                                            <span className="fw-bold text-danger">Total Balance: ₦{formatAmount(totalBalanceSum)}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-responsive-sm">
                                    <table
                                        className="table align-middle table-nowrap table table-striped table-borderless table-hover"
                                        id="itemsTable"
                                    >
                                        <thead className="table-light text-muted">
                                            <tr>
                                                <th scope="col" width="5%">#</th>
                                                <th scope="col" width="20%">Account Name</th>
                                                <th scope="col" width="10%">Amount</th>
                                                <th scope="col" width="8%">Quantity</th>
                                                <th scope="col" width="5%">Discount</th>
                                                <th scope="col" width="10%">Total Amount</th>
                                                <th scope="col" width="12%">Amount Paid</th>
                                                <th scope="col" width="10%">Balance</th>
                                                <th scope="col" width="10%">Invoice Code</th>
                                                <th scope="col" width="10%">Date</th>
                                            </tr>

                                    </thead>
                                    <tbody className="list form-check-all">
                                        {aggregatedItems.map((item, index) => (
                                            <tr key={item.customer.id}>
                                                <td>{(pagination.from ?? 1) + index}</td>
                                                <td>{item.customer.company_name}</td>
                                                <td>{formatAmount(item.amount)}</td>
                                                <td>{formatAmount(item.quantity)}</td>
                                                <td>{formatAmount(item.discount)}</td>
                                                <td>{formatAmount(item.totalAmount)}</td>
                                                <td>{formatAmount(item.amountPaid)}</td>
                                                <td>{formatAmount(item.balance)}</td>
                                                <td>{item.invoice_code}</td>
                                                <td>{formatDate(item.created_at)}</td>

                                                    <td>
                                                        <div className="dropdown">
                                                            <button
                                                                className="btn btn-icon btn-sm fs-16 text-muted dropdown"
                                                                type="button"
                                                                data-bs-toggle="dropdown"
                                                                aria-expanded="false"
                                                            >
                                                                <i className="mdi mdi-apps"></i>
                                                            </button>

                                                            <ul className="dropdown-menu">
                                                                <li>
                                                                    <Link className="dropdown-item" onClick={() => handleShowViewInvoice(item.invoice_code)}>
                                                                        <i className="ri-edit-fill text-muted me-2 align-bottom"></i>
                                                                        View invoice
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link
                                                                        className="dropdown-item"
                                                                        onClick={() => handleDownloadPdf(item.invoice_code)}
                                                                    >
                                                                        <i className="ri-download-fill text-muted me-2 align-bottom"></i>
                                                                        Download PDF
                                                                    </Link>
                                                                </li>
                                                                <li>

                                                                    <Link className="dropdown-item" onClick={() => {
                                                                        setPercentageModalOpen(true);
                                                                        // setCurrentAccountId(item.customer.id);
                                                                        sendInvoiceEmail(item.invoice_code);
                                                                    }}>
                                                                        <i className="ri-mail-fill text-muted me-2 align-bottom"></i>
                                                                        {isGeneralLoading ? (
                                                                            <>
                                                                                <Spinner
                                                                                    as="span"
                                                                                    animation="border"
                                                                                    size="sm"
                                                                                    role="status"
                                                                                    aria-hidden="true"
                                                                                />{" "}
                                                                                sending...
                                                                            </>
                                                                        ) : (
                                                                            " Send Invoice Email"
                                                                        )}
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link className="dropdown-item" onClick={() => handleShowPaymentHistory(item.invoice_code)}>
                                                                        <i className="ri-edit-fill text-muted me-2 align-bottom"></i>
                                                                        View payment history
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link className="dropdown-item" onClick={() => handleShowEditModal(item.invoice_code)}>
                                                                        <i className="ri-edit-fill text-muted me-2 align-bottom"></i>
                                                                        Edit
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link className="dropdown-item" onClick={() => handleShowPayment(item)}>
                                                                        <i className="ri-star-fill text-muted me-2 align-bottom"></i>
                                                                        Add Payment
                                                                    </Link>
                                                                </li>
                                                                <li>
                                                                    <Link className="dropdown-item" onClick={() => handleDelete(item.invoice_code)}>
                                                                        <i className="ri-star-fill text-muted me-2 align-bottom"></i>
                                                                        Delete
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    <div className="d-flex justify-content-end mt-5 mb-5">
                                        <div className="pagination-wrap hstack gap-2">
                                            <ul className="pagination listjs-pagination mb-0">
                                                {(pagination.links || []).map((link, index) => {
                                                    const pageNumber = link.url
                                                        ? new URL(link.url).searchParams.get("page")
                                                        : null;

                                                    return (
                                                        <li
                                                            key={index}
                                                            className={`page-item ${link.active ? "active" : ""
                                                                }`}
                                                        >
                                                            <button
                                                                className="page-link"
                                                                onClick={() =>
                                                                    pageNumber &&
                                                                    handlePageChange(Number(pageNumber))
                                                                }
                                                                dangerouslySetInnerHTML={{
                                                                    __html: link.label,
                                                                }}
                                                            ></button>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Component */}
            {/* <Modal show={percentageModalOpen} onHide={() => {
            setPercentageModalOpen(false);
            setCurrentAccountId(null); // Reset account ID when closing modal
        }}>
            <Modal.Header closeButton>
                <Modal.Title>Enter Upfront Percentage</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <input
                    type="number"
                    value={percentage}
                    onChange={(e) => setPercentage(e.target.value)}
                    placeholder="Enter percentage"
                    min="0" max="100"
                    className="form-control"
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    setPercentageModalOpen(false);
                    setPercentage('');
                    setCurrentAccountId(null); // Reset when cancelling
                }}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => sendInvoiceEmail(currentAccountId)}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal> */}

            {/* Include the CreateManage modal */}
            {showManageModal && (
                <CreateInvoice
                    show={showManageModal}
                    closeModal={handleCloseManageModal}
                    item={selectedItem}
                    refreshData={handleRefresh}
                />
            )}

            {/* Include the EditModal */}
            {showEditModal && (
                <EditInvoicing
                    showEdit={showEditModal}
                    closeModal={handleCloseEditModal}
                    invoiceData={selectedItem}
                    refreshData={handleRefresh}
                />
            )}
            {/* Include the EditModal */}
            {showPayment && (
                <AddCustomServicePayment
                    showPayment={showPayment}
                    closeModal={handleClosePayment}
                    itemData={selectedItem}
                    refreshData={handleRefresh}
                />
            )}

            {showViewModal && (
                <ViewInvoice
                    showView={showViewModal}
                    closeModal={handleCloseViewModal}
                    Invoice={selectedItem}
                    refreshData={handleRefresh}
                />
            )}

            {showPaymentHistory && (
                <ViewCustomFixedPayHistory
                    showHistoryView={showPaymentHistory}
                    closeModal={handleCloseViewPaymentHistory}
                    invoice_code={paymentHistories}
                    refreshData={handleRefresh}
                />
            )}

        </div>
    );
}
